/**
 * Full bundle - includes all locales and converters
 */
import { Trie, ConverterFactory, CustomConverter, ProtectedConverter, parseOpenCCDict } from "../core.js";
import { HTMLConverter } from "../html-converter.js";
import { variants2standard, standard2variants } from "../presets.js";
// Import all dictionaries
import * as dict from "../dict/index.js";
/**
 * Create a converter with the specified locales.
 *
 * @param options - Conversion options (from/to locale)
 * @param protectedDict - Optional hard-override dictionary. Matches are masked
 *   with PUA placeholders before built-in conversion, then restored — OpenCC
 *   dictionaries never see or modify them. Highest priority.
 *
 *   UMD bundles do NOT auto-load `data/custom/ProtectedDict.txt` (no fs in
 *   browsers). Pass the dict explicitly; use `parseOpenCCDict` to parse
 *   OpenCC-format text fetched at runtime.
 */
function Converter(options, protectedDict) {
    // Reject unknown locales loudly rather than silently skipping a step and
    // returning partially-converted text (JS callers bypass the TS type check).
    if (options.from !== "t" && !variants2standard[options.from]) {
        throw new Error(`Unknown 'from' locale: ${options.from}`);
    }
    if (options.to !== "t" && !standard2variants[options.to]) {
        throw new Error(`Unknown 'to' locale: ${options.to}`);
    }
    const dictGroups = [];
    // From variant to standard
    if (options.from !== "t") {
        const dictFiles = variants2standard[options.from] || [];
        const dicts = dictFiles.map((name) => dict[name]).filter(Boolean);
        if (dicts.length) {
            dictGroups.push(dicts);
        }
    }
    // From standard to variant
    if (options.to !== "t") {
        const dictFiles = standard2variants[options.to] || [];
        const dicts = dictFiles.map((name) => dict[name]).filter(Boolean);
        if (dicts.length) {
            dictGroups.push(dicts);
        }
    }
    let convert = ConverterFactory(...dictGroups);
    if (protectedDict) {
        convert = ProtectedConverter(protectedDict, convert);
    }
    return convert;
}
// Locale data for ConverterBuilder compatibility
const Locale = {
    from: Object.fromEntries(Object.entries(variants2standard).map(([locale, files]) => [locale, files.map((name) => dict[name]).filter(Boolean)])),
    to: Object.fromEntries(Object.entries(standard2variants).map(([locale, files]) => [locale, files.map((name) => dict[name]).filter(Boolean)])),
};
export { Converter, CustomConverter, ConverterFactory, ProtectedConverter, parseOpenCCDict, HTMLConverter, Locale, Trie };
//# sourceMappingURL=full.js.map